import { render, staticRenderFns } from "./PartnerHotCruiseItem.vue?vue&type=template&id=ec8067fe&scoped=true"
import script from "./PartnerHotCruiseItem.vue?vue&type=script&lang=js"
export * from "./PartnerHotCruiseItem.vue?vue&type=script&lang=js"
import style0 from "./PartnerHotCruiseItem.vue?vue&type=style&index=0&id=ec8067fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8067fe",
  null
  
)

export default component.exports